import React from 'react';
import { BundleDetailTemplate } from './BundleDetailTemplate';

export const BundleCompliance = () => <BundleDetailTemplate slug="compliance-legal" />;
